import {
  GET_All_USERS,
  ADD_REGISTERED_USER,
  REMOVE_USER,
  REMOVE_ADDED_USER,
  GET_USER_BY_ID,
  CURRENT_USER,
  USER_TOTAL_PAGE,
  ALL_USERS_CURRENT_PAGE,
  SET_SEARCH_USERS_PARAMS,
  GET_ACCESS_LIST,
  ACCESS_LIST_CURRENT_PAGE,
  ACCESS_LIST_TOTAL_PAGES,
  REMOVE_SINGLE_ACCESS,
  GET_ACCESS_LIST_MANAGEMENT,
  AL_MANAGEMENT_CURRENT_PAGE,
  AL_MANAGEMENT_TOTAL_PAGES,
  REMOVE_SINGLE_AL_MANAGEMENT,
  GET_ADMIN_LOGS,
  ADMIN_LOGS_CURRENT_PAGE,
  ADMIN_LOGS_TOTAL_COUNT,
  GET_SINGLE_ADMIN_LOG,
  SET_ADMIN_LOG_DB,
} from "../../@jumbo/constants/ActionTypes";

export const setAllUsers = (users) => {
  return (dispatch) => {
    dispatch({
      type: GET_All_USERS,
      payload: users,
    });
  };
};
export const addRegisteredUser = (users) => {
  return (dispatch) => {
    dispatch({
      type: ADD_REGISTERED_USER,
      payload: users,
    });
  };
};
export const removeUser = (userId) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_USER,
      payload: userId,
    });
  };
};
export const removeAddedUser = (userId) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_ADDED_USER,
      payload: userId,
    });
  };
};
export const setSingleUser = (userId) => {
  return (dispatch) => {
    dispatch({
      type: GET_USER_BY_ID,
      payload: userId,
    });
  };
};
export const setCurrentUser = (user) => {
  return (dispatch) => {
    dispatch({
      type: CURRENT_USER,
      payload: user,
    });
  };
};
export const setUsersTotalPages = (pages) => {
  return (dispatch) => {
    dispatch({
      type: USER_TOTAL_PAGE,
      payload: pages,
    });
  };
};
export const setAllUsersCurrentPage = (page) => {
  return (dispatch) => {
    dispatch({
      type: ALL_USERS_CURRENT_PAGE,
      payload: page,
    });
  };
};
export const setUserSearchParams = (searchParams) => {
  return (dispatch) => {
    dispatch({
      type: SET_SEARCH_USERS_PARAMS,
      payload: searchParams,
    });
  };
};
export const setAccessList = (accessList) => {
  return (dispatch) => {
    dispatch({
      type: GET_ACCESS_LIST,
      payload: accessList,
    });
  };
};
export const setAccessListCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: ACCESS_LIST_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};
export const setAccessListTotalPages = (totalPages) => {
  return (dispatch) => {
    dispatch({
      type: ACCESS_LIST_TOTAL_PAGES,
      payload: totalPages,
    });
  };
};
export const removeSingleUserAccess = (userId) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_SINGLE_ACCESS,
      payload: userId,
    });
  };
};
export const setAccessManagementList = (accessList) => {
  return (dispatch) => {
    dispatch({
      type: GET_ACCESS_LIST_MANAGEMENT,
      payload: accessList,
    });
  };
};
export const setAccessMangementListCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: AL_MANAGEMENT_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};
export const setAccessManagementListTotalPages = (totalPages) => {
  return (dispatch) => {
    dispatch({
      type: AL_MANAGEMENT_TOTAL_PAGES,
      payload: totalPages,
    });
  };
};
export const removeSingleUserAccessMangement = (userId) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_SINGLE_AL_MANAGEMENT,
      payload: userId,
    });
  };
};
export const setAdminLogs = (adminLogs) => {
  return (dispatch) => {
    dispatch({
      type: GET_ADMIN_LOGS,
      payload: adminLogs,
    });
  };
};

export const setAdminLog = (adminLog) => {
  return (dispatch) => {
    dispatch({
      type: GET_SINGLE_ADMIN_LOG,
      payload: adminLog,
    });
  };
};

export const setAdminLogsCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: ADMIN_LOGS_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};

export const setAdminLogsTotalPages = (totalPages) => {
  return (dispatch) => {
    dispatch({
      type: ADMIN_LOGS_TOTAL_COUNT,
      payload: totalPages,
    });
  };
};

export const setAdminLogDB = (adminLogDB) => {
  return (dispatch) => {
    dispatch({
      type: SET_ADMIN_LOG_DB,
      payload: adminLogDB,
    });
  };
};  